export default "__VITE_ASSET__DuOhuvGR__"